---
nb:
  liquidity:
    actual: Faktisk
    base: Base
    data_sources:
      owner: Eier
      simulation: Simulering
    expected: Forventet
    file_processed: Filen ble prosessert
    file_too_large: Filen er for stor
    invalid_file: Filen kunne ikke leses. Den kan være skadet eller i feil format.
    liquidity: Likviditetsplanlegging
    mean_historical: Gjennomsnitt av historiske data
    no_data_for_chart: Det er ingen data for dette diagrammet for valgte filtre.
    production: Produksjon
    pxx_production: P%{number} Produksjon
    pxx_spot_price: P%{number} Spotpris
    revenue: Inntekt
    sim_high: Simulert Høy
    sim_low: Simulert Lav
    simulated_production: Simulert produksjon
    simulated_revenue_development: Likviditetsutvikling
    spot_price: Spot pris
    variation: Variasjon
